export default {
  get: `{ getHealth {
    version
    } }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/version.js